
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-and-secret",
      function () {
        return require("private-next-pages/password-and-secret/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password-and-secret"])
      });
    }
  